import mapboxgl from 'mapbox-gl';

import { LatLng, LngLat } from './types';
import { latLngToLngLat } from './utils';

export const getBoundsFromLatLng = (latLng: LatLng[]) => {
  const lngLat = latLngToLngLat(latLng) as LngLat[];
  const bounds = new mapboxgl.LngLatBounds();

  lngLat.map((p) => {
    const point = new mapboxgl.LngLat(p[0], p[1]);
    return bounds.extend(point);
  });

  return bounds;
};
